/** Chip `color` prop for collection percentage (header). */
export function dashboardCollectionChipColor(percentage: number): "success" | "warning" | "error" {
  if (percentage >= 80) return "success";
  if (percentage >= 50) return "warning";
  return "error";
}

/** MUI palette path for collection progress bar fill. */
export function dashboardCollectionProgressBarColor(percentage: number): string {
  if (percentage >= 80) return "success.main";
  if (percentage >= 50) return "warning.main";
  return "error.main";
}

export function formatDashboardStatValue(
  value: number | string,
  valueType: "currency" | "count"
): string {
  if (typeof value === "string") {
    return value;
  }
  if (valueType === "count") {
    return value.toLocaleString("en-IN");
  }
  return `₹${value.toLocaleString("en-IN")}`;
}

export function formatDashboardCurrencyAmount(amount: number): string {
  return `₹${(amount || 0).toLocaleString("en-IN")}`;
}
